import { api } from ":mods";
import { CONST, model } from "..";

export async function listGet(stage: string | number) {
  return api.getAuth(CONST.ENDPOINTS.admin.list_resources(stage)).then((res) => res.data as model.ResourcesList);
}
